/*
Sohel 11/01/2023 5314488544 new MUI table Implemented table data
uday 3-11-23 5314488544 fixed eligibility ui changes
sohel 11/04/2023 5314488544 fixed extra space issue
*/

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  link: {
    // Changed field list code column font color (2700799562)
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
  detailsCard: {
    padding: '15px !important',
    display: 'flex',
    flexDirection: 'column',
  },
  mainHeading: {
    fontWeight: 'bold !important',
    fontSize: '1rem',
    fontFamily: 'articulat-cf, sans-serif !important',
    marginBottom: '20px',
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '0.875rem',
    color:"#707070",
    fontFamily: 'articulat-cf, sans-serif !important',
  },
  pronoSection: {
    borderBottom: '1px solid #0000004f',
    margin: '10px 5px 15px',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
}));
const EligibilityCoverageInfoUI = ({ coverageInfoData }) => {
  const classes1 = useStyles();
  return (
    <>
      {coverageInfoData?.map((el, index) => {
        return (
          <>
            <div className={classes1.pronoSection}>
              <h6 className={classes1.mainHeading}>Plan Details : {index + 1}</h6>
              <div className="row mb-2">
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Payer Id : <span className="processor-label">{el?.insurancePayerId}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Payer Name : <span className="processor-label">{el?.insurancePayerName}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Insurance Type : <span className="processor-label">{el?.insuranceType}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Status : <span className="processor-label">{el?.insuranceStatus}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Plan Description :
                    <span className="processor-label">&nbsp;{el?.insurancePlanDescription}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Group Description :
                    <span className="processor-label">&nbsp;{el?.insuranceGroupDescription}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Member Id :
                    <span className="processor-label">&nbsp;{el?.insuranceSubscriberId}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Group Number :
                    <span className="processor-label">&nbsp;{el?.insuranceGroupNumber}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Start Date :
                    <span className="processor-label">
                      &nbsp;
                      {el?.insuranceStartDate
                        ? moment(el?.insuranceStartDate).format('MM/DD/YYYY')
                        : ''}
                    </span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    End Date :
                    <span className="processor-label">
                      &nbsp;
                      {el?.insuranceEndDate
                        ? moment(el?.insuranceEndDate).format('MM/DD/YYYY')
                        : ''}
                    </span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Added Date :
                    <span className="processor-label">
                      &nbsp;
                      {el?.insuranceAddedDate
                        ? moment(el?.insuranceAddedDate).format('MM/DD/YYYY')
                        : ''}
                    </span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Issue Date :
                    <span className="processor-label">
                      &nbsp;
                      {el?.insuranceIssueDate
                        ? moment(el?.insuranceIssueDate).format('MM/DD/YYYY')
                        : ''}
                    </span>
                  </Typography>
                </div>
              </div>
              {/* <h6 className={classes1.mainHeading}>Insured Details :</h6> */}
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Insured First Name :
                    <span className="processor-label">&nbsp;{el?.insuredFirstName}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Insured Last Name :
                    <span className="processor-label">&nbsp;{el?.insuredLastName}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Insured DOB :
                    <span className="processor-label">
                      &nbsp;
                      {el?.insuredBirthDate
                        ? moment(el?.insuredBirthDate).format('MM/DD/YYYY')
                        : ''}
                    </span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Relation To Insured :
                    <span className="processor-label">
                      &nbsp;{el?.insuranceRelationToSubscriber}
                    </span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Insured Address 1 :
                    <span className="processor-label">&nbsp;{el?.insuredAddressLine1}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Insured Address 2 :
                    <span className="processor-label">&nbsp;{el?.insuredAddressLine2}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Insured City : <span className="processor-label">{el?.insuredCity}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Insured State : <span className="processor-label">{el?.insuredState}</span>
                  </Typography>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 form-group">
                  <Typography className={classes1.heading}>
                    Insured Zip : <span className="processor-label">{el?.insuredZip}</span>
                  </Typography>
                </div>
              </div>
            </div>
          </>
        );
      })}
    </>
  );
};

export default EligibilityCoverageInfoUI;
